import React, { useCallback, useEffect, useRef, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs } from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { child, getDatabase, push, update } from "firebase/database";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { v4 } from "uuid";
import { db, storage } from "../firebase/firebase";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { CircularProgressbar } from "react-circular-progressbar";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function Editplan() {
  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setWeeks(result);
  };

  const navigate = useNavigate();

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  const refObj = useRef(null);

  const [weeks, setWeeks] = useState(0);
  const [name, setName] = useState("Laden...");
  const [level, setLevel] = useState(0);
  const [desc, setDesc] = useState("");
  const [type, setType] = useState("");
  const [weekList, setWeekList] = useState([]);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [isModalEditDay, setIsModalEditDay] = useState(false);
  const [isModalAddWeek, setIsModalAddWeek] = useState(false);
  const [isModalAddDay, setIsModalAddDay] = useState(false);
  const [selWeek, setSelWeek] = useState([]);
  const [selDay, setSelDay] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [refHeight, setRefHeight] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [mediaLink, setMediaLink] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [uploadedData, setUploadedData] = useState(false);
  const [loadingValue, setLoadingValue] = useState(0);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      }
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const onDrop = useCallback((acceptedFiles) => {
    setImageUpload(acceptedFiles[0]);
    uploadImage(acceptedFiles[0]);
  }, []);

  const uploadImage = async (data) => {
    var sendData = imageUpload;

    if (imageUpload == null && data == null) return;

    if (sendData == null) {
      sendData = data;
    }

    setIsLoading(true);

    var dataName = sendData.name + "_" + v4();

    const storage = getStorage();
    const storageRef = ref(storage, `exercises/${dataName}`);

    setMediaUrl(dataName);

    const uploadTask = uploadBytesResumable(storageRef, sendData);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setLoadingValue(progress);
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        alert("Fehler bei Hochladen: " + error);
      },
      () => {
        setUploadedData(true);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setMediaLink(downloadURL);
          console.log("File available at", downloadURL);
        });
      }
    );
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  const [imageUpload, setImageUpload] = useState(null);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const updateHeight = async () => {
    if (refObj.current) {
      await timeout(500);
      setRefHeight(refObj?.current?.offsetHeight);
    }
  };

  useEffect(() => {
    if (isModalAddDay) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isModalAddDay]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const selPage = "plans";

  const [weekTitles, setWeekTitles] = useState([
    "Woche",
    // "Details",
    "Tag 1",
    "Tag 2",
    "Tag 3",
    "Tag 4",
    "Tag 5",
    "Tag 6",
    "Tag 7",
  ]);

  function addSelDay(day) {
    var help = [];

    weekList.map((obj, index) => {
      if (index == selDay.indexWeek) {
        var help2 = obj;

        help2.days[selDay.indexDay] = {
          name_de: day.name_de,
          workoutId: day.id,
          shortDesc_de: day.desc_de,
          information_de:
            "Der angegebene Puls dient als Richtwert - Versuche ihn so gut es geht einzuhalten.",
          type: day.type,
          time: day.time,
        };

        help.push(help2);
      } else {
        help.push(obj);
      }
    });

    setWeekList(help);

    setIsModalAddDay(false);
  }

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function RenderWeekTitle() {
    return weekTitles.map((obj) => (
      <th
        style={{
          border: "1px solid hsl(210, 14%, 83%)",
          borderBottom: "1px solid hsl(210, 14%, 83%)",
          height: 55,
        }}
      >
        <a>{obj}</a>
      </th>
    ));
  }

  function editWeek(obj, index) {
    var help = [{ ...obj, index: index }];

    setSelWeek(null);

    setSelWeek(help[0]);

    setIsModalEdit(true);
  }

  function addDay(obj, indexDay, indexWeek) {
    setSelDay({
      ...obj,
      indexDay: indexDay,
      indexWeek: indexWeek,
      information_de:
        "Der angegebene Puls dient als Richtwert - Versuche ihn so gut es geht einzuhalten.",
    });

    setIsModalAddDay(true);
    updateHeight();
  }

  function editDay() {
    setIsModalEditDay(true);
  }

  function addWeek() {
    var help = [
      {
        ...selWeek,
        name_de: "",
        desc_de: "",
        tier: 1,
        days: [
          { name_de: "" },
          { name_de: "" },
          { name_de: "" },
          { name_de: "" },
          { name_de: "" },
          { name_de: "" },
          { name_de: "" },
        ],
      },
    ];
    setSelWeek(null);
    setSelWeek(help[0]);

    setIsModalAddWeek(true);
  }

  function saveWeek() {
    var help = [];

    weekList.map((obj, index) => {
      if (index == selWeek.index) {
        help.push(selWeek);
      } else {
        help.push(obj);
      }
    });

    setWeekList(help);

    setIsModalEdit(false);
  }

  function saveNewWeek() {
    if (selWeek.name_de == "" || selWeek.desc_de == "") {
      alert("Bitte alle Daten angeben.");
      return;
    }

    var help = [];

    weekList?.map((obj, index) => {
      help.push(obj);
    });

    help.push(selWeek);

    setWeekList(help);

    setIsModalAddWeek(false);
  }

  function RenderWeeks({ obj, index }) {
    var help = [];

    help.push(
      <th
        style={{
          border: "1px solid hsl(210, 14%, 83%)",
          borderBottom: "1px solid hsl(210, 14%, 83%)",
          height: 55,
          borderRight: "0px solid hsl(210, 14%, 83%)",
          paddingLeft: 0,
          paddingRight: 0,
          cursor: "pointer",
        }}
        onClick={() => {
          editWeek(obj, index);
        }}
      >
        <a
          style={{
            color: "#000",
            paddingRight: 0,
            // borderRadius: 999,
            marginRight: 10,
            // width: 20,
            // height: 20,
          }}
        >
          {JSON.stringify(index + 1)}
        </a>
        <i
          style={
            {
              // marginTop: -0,
              // marginLeft: -10,
              // position: "absolute",
              // fontSize: 12,
              // backgroundColor: "#000",
              // borderRadius: 999
            }
          }
        >
          <FontAwesomeIcon
            style={{ color: "#000", width: 15, height: 15 }}
            icon={icon({ name: "pen-to-square", style: "solid" })}
          />
        </i>
      </th>
    );

    weekList[index]?.days?.map((obj, indexDay) => {
      help.push(
        <th
          style={{
            border: "1px solid hsl(210, 14%, 83%)",
            borderBottom: "1px solid hsl(210, 14%, 83%)",
            height: 55,
            backgroundColor: obj?.name_de == "" ? "transparent" : "#ecf5ff",
            cursor: "pointer",
          }}
          onClick={() => {
            if (obj?.name_de != "") {
              setSelDay({ ...obj, indexDay: indexDay, indexWeek: index });
              editDay();
            } else {
              addDay(obj, indexDay, index);
            }
          }}
        >
          <a>{obj?.name_de != "" ? " " : "+"}</a>

          {obj?.name_de != "" && (
            <i style={{ color: "#000" }} className="fa-solid fa-bars">
              <FontAwesomeIcon
                icon={icon({ name: "pencil", style: "solid" })}
              />
            </i>
          )}
        </th>
      );
    });

    return <>{help}</>;
  }

  useEffect(() => {
    function getUrlVars() {
      return getParameterByName("planid");
    }

    const loadPlan = async () => {
      const q = query(
        collection(db, "plans"),
        where("__name__", "==", getUrlVars())
      );

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        setName(doc.data().name_de);
        setLevel(doc.data().level);
        setDesc(doc.data().desc_de);
        setWeeks(doc.data().duration);
        setType(doc.data().type);
        setWeekList(doc.data().weeks);
        setWeekList(doc.data().weeks);
        setMediaLink(doc.data().media_link);
        setMediaUrl(doc.data().media_url);
        setIsActive(doc.data().isActive);
      });
    };

    const loadSessions = async () => {
      const q = query(collection(db, "workouts"));

      const querySnapshot = await getDocs(q);
      const elements = [];

      querySnapshot.forEach((doc) => {
        elements.push(doc.data());
      });

      setSessions(elements);
    };

    loadPlan();
    loadSessions();
  }, []);

  const ondeletePlan = async () => {
    const refPlan = doc(db, "plans", getParameterByName("planid"));

    await updateDoc(refPlan, {
      isActive: false,
    });

    window.location.replace("plans");
  };

  function deletePlan() {
    window.confirm("Diesen Plan wirklich löschen?") && ondeletePlan();
  }

  function deleteDay() {
    var help = [];

    weekList.map((obj, index) => {
      if (index == selDay.indexWeek) {
        var help2 = obj;

        help2.days[selDay.indexDay] = { name_de: "" };

        help.push(help2);
      } else {
        help.push(obj);
      }
    });

    setWeekList(help);

    setIsModalEditDay(false);
  }

  function deleteWeek() {
    var help = [];

    weekList.map((obj, index) => {
      if (index == selWeek.index) {
      } else {
        help.push(obj);
      }
    });

    setWeekList(help);

    setIsModalEdit(false);
  }

  const onEditPlan = async () => {
    const refPlan = doc(db, "plans", getParameterByName("planid"));

    if (
      name != "" &&
      desc != "" &&
      type != "" &&
      mediaLink != "" &&
      weekList != undefined
    ) {
      await updateDoc(refPlan, {
        name_de: name,
        desc_de: desc,
        duration: weekList.length,
        level: level,
        type: type,
        weeks: weekList,
        media_link: mediaLink ? mediaLink : "",
        media_url: mediaUrl ? mediaUrl : "",
        isActive: isActive ? isActive : false,
      });

      alert("Gespeichert.");
    } else {
      alert("Bitte alle Daten angeben.");

      if (mediaLink == "") {
        alert("Bitte ein Bild angeben.");
      }

      if (weekList == undefined) {
        alert("Bitte mindestens eine Woche einfügen.");
      }
    }
  };

  const Content = () => (
    <section className="home-section">
      <div className="text">Plan bearbeiten</div>

      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className="plan-data"
        id="plan-data"
      >
        <div className="container">
          <h2 id="plan-title">{name}</h2>
          <form className="contact-form">
            <p>Name</p>

            <input
              type="search"
              className="plan-name"
              placeholder="Name"
              id="plan-name"
              value={name}
              onChange={(evt) => {
                setName(evt.target.value);
              }}
            />
            <p>Beschreibung</p>
            <textarea
              style={{ resize: "vertical", maxHeight: "none" }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
            ></textarea>
            <p>Typ</p>
            <input
              value={type}
              onChange={(evt) => {
                setType(evt.target.value);
              }}
              type="search"
              className="plan-type"
              placeholder="Ausdauer, Kraft..."
              id="plan-type"
            />

            <p>Level</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={level}
              onChange={(evt) => {
                setLevel(Number(evt.target.value));
              }}
            >
              <option value="0">Anfänger</option>
              <option value="1">Fortgeschritten</option>
              <option value="2">Profi</option>
            </select>

            <div style={{ height: 20 }}></div>

            {isAdmin && (
              <a
                style={{ cursor: "pointer", marginTop: 20 }}
                onClick={() => {
                  setIsActive(!isActive);
                }}
              >
                <div className="list-container">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid hsl(210, 14%, 83%)",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    className="list-item"
                  >
                    <p
                      style={{
                        padding: 2,
                        border: "1px solid hsl(210, 14%, 83%)",
                        marginRight: 15,
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ color: isActive ? "#21252b" : "transparent" }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </p>
                    <p style={{ color: "#000", fontSize: 14 }}>
                      {"Öffentlich"}
                    </p>
                  </div>
                </div>
              </a>
            )}

            <p>Bild</p>

            <>
              {mediaLink != "" && mediaLink ? (
                <>
                  <FontAwesomeIcon
                    onClick={() => {
                      setMediaLink("");
                    }}
                    style={{
                      backgroundColor: "#7a3260",
                      padding: 5,
                      borderRadius: 999,
                      width: "15px",
                      height: "15px",
                      color: "#fff",
                      position: "absolute",
                      zIndex: 999,
                      marginTop: 10,
                      marginLeft: 10,
                      cursor: "pointer",
                    }}
                    icon={icon({ name: "close", style: "solid" })}
                  />

                  <img style={{ width: "50%" }} src={mediaLink}></img>
                </>
              ) : (
                <>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {uploadedData ? (
                      <>
                        <div
                          className={
                            "dropzone " +
                            (isDragActive ? "active-dropzone" : "")
                          }
                          style={{ padding: 30 }}
                        >
                          <i
                            style={{
                              color: "#fff",
                              backgroundColor: "#7a3260",
                              borderRadius: 999,
                              padding: 10,
                            }}
                            className="fa-solid fa-check"
                          >
                            <FontAwesomeIcon
                              style={{ width: 60, height: 60 }}
                              icon={icon({ name: "check", style: "solid" })}
                            />
                          </i>
                          <span>{imageUpload.name}</span>
                        </div>
                      </>
                    ) : isLoading ? (
                      <div
                        className={
                          "dropzone " + (isDragActive ? "active-dropzone" : "")
                        }
                        style={{ padding: 30 }}
                      >
                        <CircularProgressbar value={loadingValue} />
                        <span>Datei wird hochgeladen...</span>
                      </div>
                    ) : (
                      <>
                        <div
                          className={
                            "dropzone " +
                            (isDragActive ? "active-dropzone" : "")
                          }
                        >
                          <span>Drag and Drop</span>
                          <span>oder</span>
                          <label htmlFor="dropzoneFile">Datei auswählen</label>
                          <input
                            onChange={(evt) => {
                              setImageUpload(evt.target.files[0]);
                              uploadImage(evt.target.files[0]);
                            }}
                            type="file"
                            id="dropzoneFile"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </>

            <p>Wochen</p>

            <table className="list-item-editplan" style={{ width: "100%" }}>
              {weekList?.length > 0 && (
                <thead style={{ width: "1000px" }}>
                  <tr
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <RenderWeekTitle></RenderWeekTitle>
                  </tr>
                </thead>
              )}
              <tbody>
                {weekList?.map((obj, index) => {
                  return (
                    <tr style={{ backgroundColor: "#fff" }}>
                      <RenderWeeks obj={obj} index={index}></RenderWeeks>
                    </tr>
                  );
                })}

                <tr>
                  <td colspan="9" style={{}}>
                    <a
                      onClick={() => {}}
                      style={{ borderTop: "1px solid hsl(210, 14%, 83%)" }}
                      className="list-container"
                    >
                      <div
                        onClick={() => {
                          addWeek();
                        }}
                        className="list-item add-workout"
                      >
                        <i
                          style={{ color: "#7a3260" }}
                          className="fa-solid fa-bars"
                        >
                          <FontAwesomeIcon
                            icon={icon({ name: "plus", style: "solid" })}
                          />
                        </i>
                        <p>{"Woche hinzufügen"}</p>
                      </div>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>

          <div className="form-button">
            <div style={{ display: "flex" }}>
              <button
                onClick={() => onEditPlan()}
                className="btn submit-form"
                type="submit"
              >
                Speichern
              </button>

              <div style={{ width: 10 }}></div>

              <button
                onClick={() => navigate(-1)}
                className="btn btn-gray submit-form"
                type="submit"
              >
                Abbrechen
              </button>

              <div style={{ width: 10 }}></div>
            </div>
            <button
              onClick={() => deletePlan()}
              className="btn btn-red submit-form"
              type="submit"
            >
              Löschen
            </button>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {/* Edit Week Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalEdit ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          className={"mobile-nav " + (isModalEdit ? "slide-in" : "slide-out")}
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {selWeek?.name_de}
            </p>

            <p style={{ color: "#fff", paddingBottom: 10 }}>{"Name:"}</p>

            <input
              type="search"
              placeholder="Name"
              value={selWeek?.name_de}
              onChange={(evt) => {
                var help = [{ ...selWeek, name_de: evt.target.value }];

                setSelWeek(null);

                setSelWeek(help[0]);
              }}
              className="plan-weeks"
            />

            <p style={{ color: "#fff", paddingBottom: 10 }}>
              {"Beschreibung:"}
            </p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={selWeek?.desc_de}
              onChange={(evt) => {
                var help = [{ ...selWeek, desc_de: evt.target.value }];

                setSelWeek(null);

                setSelWeek(help[0]);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
              style={{
                resize: "none",
              }}
            ></textarea>

            <div style={{ paddingBottom: 15 }}></div>

            <p style={{ color: "#fff", paddingBottom: 10 }}>{"Intensität:"}</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={selWeek?.tier}
              onChange={(evt) => {
                var help = [{ ...selWeek, tier: Number(evt.target.value) }];
                setSelWeek(null);
                setSelWeek(help[0]);
              }}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>

            <p></p>
          </form>

          <button
            onClick={() => {
              saveWeek();
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 0, marginRight: 10 }}
          >
            Speichern
          </button>

          <button
            onClick={() => {
              setIsModalEdit(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>

          <p></p>

          <button
            onClick={() => deleteWeek()}
            className="btn btn-red submit-form"
            type="submit"
            style={{ marginRight: 20 }}
          >
            Entfernen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalEdit(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
          }}
        ></div>
      </div>

      {/* Edit Day Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalEditDay ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          className={
            "mobile-nav " + (isModalEditDay ? "slide-in" : "slide-out")
          }
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {selDay?.name_de}
            </p>

            <p></p>
          </form>

          <p></p>

          <button
            onClick={() => deleteDay()}
            className="btn btn-red submit-form"
            type="submit"
            style={{ marginRight: 20 }}
          >
            Entfernen
          </button>

          <button
            onClick={() => {
              setIsModalEditDay(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalEditDay(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2, //"50%",
            width: windowDimensions.width - 600, //"50%",
            minHeight: "100%",
          }}
        ></div>
      </div>

      {/* Add Week Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalAddWeek ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          className={
            "mobile-nav " + (isModalAddWeek ? "slide-in" : "slide-out")
          }
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {"Woche hinzufügen"}
            </p>

            <p style={{ color: "#fff", paddingBottom: 10 }}>{"Name:"}</p>

            <input
              type="search"
              placeholder="Name"
              value={selWeek?.name_de}
              onChange={(evt) => {
                var help = [{ ...selWeek, name_de: evt.target.value }];
                setSelWeek(null);
                setSelWeek(help[0]);
              }}
              className="plan-weeks"
            />

            <p style={{ color: "#fff", paddingBottom: 10 }}>
              {"Beschreibung:"}
            </p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={selWeek?.desc_de}
              onChange={(evt) => {
                var help = [{ ...selWeek, desc_de: evt.target.value }];
                setSelWeek(null);
                setSelWeek(help[0]);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
              style={{
                resize: "none",
              }}
            ></textarea>

            <div style={{ paddingBottom: 15 }}></div>

            <p style={{ color: "#fff", paddingBottom: 10 }}>{"Intensität:"}</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={selWeek?.tier}
              onChange={(evt) => {
                var help = [{ ...selWeek, tier: Number(evt.target.value) }];
                setSelWeek(null);
                setSelWeek(help[0]);
              }}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>

            <p></p>
          </form>

          <button
            onClick={() => {
              saveNewWeek();
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 0, marginRight: 10 }}
          >
            Hinzufügen
          </button>

          <button
            onClick={() => {
              setIsModalAddWeek(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>

          <p></p>
        </ul>

        <div
          onClick={() => {
            setIsModalAddWeek(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
          }}
        ></div>
      </div>

      {/* Add Day Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalAddDay ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          ref={refObj}
          className={"mobile-nav " + (isModalAddDay ? "slide-in" : "slide-out")}
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {"Wähle eine Trainingseinheit:"}
            </p>

            {sessions.map((obj) => (
              <a
                style={{ cursor: "pointer" }}
                onClick={() => {
                  addSelDay(obj);
                }}
                key={"workoutpicker" + 1}
              >
                <div key={1} className="list-container">
                  <div
                    style={{ backgroundColor: "#fff" }}
                    className="list-item"
                  >
                    <p style={{ color: "#000", paddingLeft: 10 }}>
                      {obj?.name_de}
                    </p>
                  </div>
                </div>
              </a>
            ))}

            <p></p>
          </form>
          <button
            onClick={() => {
              setIsModalAddDay(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalAddDay(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
            height: refHeight,
          }}
        ></div>
      </div>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
